import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import {countertopGroupThumbnail} from "../assets";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PLACEMENTS} from "../constants";

import Countertop from "../subparts/countertop/countertop";
import Faucet from "../subparts/countertop/faucet";
import Sink from "../subparts/countertop/sink";
import Stovetop from "../subparts/countertop/stovetop";

import Cutouts from "../subparts/countertop/cutouts";
import EdgeProfile from "../subparts/countertop/edgeProfile";
import Radius from "../subparts/countertop/radius";

export default class CountertopGroup extends Part {
  static id = 'Countertop';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Countertop';
    this.partThumbnail = countertopGroupThumbnail;
    this.translateId = "visualizer.kitchen.countertop";

    // related items
    this.countertop = null;
    this.faucet = null;
    this.sink = null;

    this.edge = null;
    this.cutouts = null;
    this.radius = null;
  }

  load(dbFeature) {
    let relatedItemName = "",
      shouldLoadInDifferentGroups = false,
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Countertop":
        relatedItemName = "countertop";
        RelatedItemClass = Countertop;
        break;
      case "Edge Profile":
        shouldLoadInDifferentGroups = true;
        relatedItemName = "edge";
        RelatedItemClass = EdgeProfile;
        break;
      case "Cutouts":
        relatedItemName = "cutouts";
        RelatedItemClass = Cutouts;
        break;
      case "Radius":
        relatedItemName = "radius";
        RelatedItemClass = Radius;
        break;
      case "Faucet":
        if ((dbFeature.metaData["Placement"] && dbFeature.metaData["Placement"].includes(PLACEMENTS.Countertop)) || !dbFeature.metaData["Placement"]) {
          if (!dbFeature.metaData["Placement"]) {
            shouldLoadInDifferentGroups = true;
          }
          relatedItemName = "faucet";
          RelatedItemClass = Faucet;
        }
        break;
      case "Sink":
        if ((dbFeature.metaData["Placement"] && dbFeature.metaData["Placement"].includes(PLACEMENTS.Countertop)) || !dbFeature.metaData["Placement"]) {
          if (!dbFeature.metaData["Placement"]) {
            shouldLoadInDifferentGroups = true;
          }
          relatedItemName = "sink";
          RelatedItemClass = Sink;
        }
        break;
      case "Stovetop":
        if ((dbFeature.metaData["Placement"] && dbFeature.metaData["Placement"].includes(PLACEMENTS.Countertop)) || !dbFeature.metaData["Placement"]) {
          if (!dbFeature.metaData["Placement"]) {
            shouldLoadInDifferentGroups = true;
          }
          relatedItemName = "stovetop";
          RelatedItemClass = Stovetop;
        }
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        this.relatedItems.push(this[relatedItemName]);
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return !shouldLoadInDifferentGroups;
    }
    return false
  }

  navigationItem() {
    return new DesignNavigationItem('Countertop', this);
  }

  isSubTypeWithItems() {
    return false;
  }

  handleSubPartClick() {

  }

  subParts(withHidden = true, hideWithoutFeatures = false) {
    return this.getRelatedItems()
      .filter(item => {
        if (hideWithoutFeatures && (item.partId === "cutouts" || item.partId === "radius")) {
          return false
        }
        return this.filterRelatedItem(item, withHidden)
      })
      .map(_ => new DesignNavigationItem(_.partName, _));
  }

}
